/* store para manejar todos los limites generales de un evento */

import { create } from "zustand";
import { api } from "../services/api";

const useEventoLimitesStore = create((set, get) => ({
  limitesPorEvento: {},
  TTL: 10 * 60 * 1000,

  fetchLimitesEvento: async (eventId, force = false) => {
    const cached = get().limitesPorEvento[eventId];
    if (!force && cached && Date.now() - cached.lastFetch < get().TTL) {
      return cached.data;
    }
    try {
      const response = await api.limites.getLimitesEvento(eventId);
      if (response.status === "success") {
        set((s) => ({
          limitesPorEvento: {
            ...s.limitesPorEvento,
            [eventId]: { data: response.data, lastFetch: Date.now() },
          },
        }));
        return response.data;
      }
    } catch (e) {
      console.error("[EVENTO_LIMITES] Error:", e);
    }
    return null;
  },

  getLimitesEvento: (eventId) =>
    get().limitesPorEvento[eventId]?.data ?? null,

  invalidarEvento: (eventId) => {
    set((s) => {
      const nuevo = { ...s.limitesPorEvento };
      delete nuevo[eventId];
      return { limitesPorEvento: nuevo };
    });
  },

  reset: () => set({ limitesPorEvento: {} }),
}));

export default useEventoLimitesStore;
